import React from 'react';

import Logo from '../../components/Logo/Logo';
import { browserHistory } from 'react-router'
import { modal } from '../../core/utilities/modal';
import { lease } from '../../core/controllers/Lease.js';

import moment from 'moment'

export default class ElectronicLeaseSigning extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            requestId : props.requestId,
            isPending: 0,
            agreement: null,
            name: '',
            contract: {
                title: '',
                payment_recurrence_method: '',
                contract_amount: 0,
                security_deposit: 0,
                rent_due_day: '',
                contract_expiration_date: ''
            },
            tenant: '',
            didSign: false
        };
    }

    currencyFormat(num) {
        return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    componentDidMount() {
        var self = this;
        lease.getElectronicSignature(this.state.requestId, function(response) {
            self.setState({
                isPending: response.data.signature.pending,
                contract: response.data.contract,
                agreement: response.data.agreement,
                tenant: response.data.tenant
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextState.agreement == null || nextState.isPending == 0) {
            modal.showInfo("Invalid signature request.", "warning", "top", "center");
            browserHistory.replace('/login');
        }
    }

    sign() {
        lease.sendElectronicSignature(this.state, function(response) {
            modal.showInfo("Lease agreement signed! Log in at anytime to manage your account.", "success", "top", "center");
            browserHistory.replace('/login');
        });
    }

    signatureChange(e) {
        var didSign = true;
        if (e.target.value == '') {
            didSign = false;
        }
        this.setState({
            name: e.target.value,
            didSign: didSign
        });
    }

    render(){
        const agreement = this.state.agreement;
        const contract = this.state.contract;
        const tenant = this.state.tenant;
        const name = this.state.name;
        var disabled = 'disabled';
        if (this.state.didSign) {
            disabled = '';
        }

        if (contract.payment_recurrence_method == 'month') {
            contract.payment_recurrence_method = 'Monthly';
        }
        return (
            <div>
            <img class="background-image" src="/assets/img/kc_downtown.png" />
            <div class="login-page screen-page">
                <div class="login-box">
                    <div class="logo">
                        <a href="#"><Logo width={150} /></a>
                    </div>
                    <div class="login-logo">
                        <a href="#"><b>Hey, </b>{ tenant }!</a>
                    </div>
                    <div class="login-box-body">
                        <div class="card">
                            <div class="header">
                                <h4 class="title" style={{textAlign: 'center', padding: '10px'}}>E-Signature for Lease Agreement: {contract.title}</h4>
                                <p class="category"></p>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                { agreement == null ? (
                                    <img class="aspect-fit" src="/assets/img/Artboard@4x-8.png" width="100%"/>
                                ) : (
                                    <object width="100%" height="750px" data={agreement.url} type="application/pdf"></object>
                                )}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                <div class="header">
                                    <div class="row">
                                        <span class="info-box-icon blue-icon-circle"><i class="pe-7s-pen"></i></span>
                                        <h4 class="title" style={{marginTop: '30px', marginLeft: '10px', float: 'left'}}>Lease Terms</h4>
                                        <p class="category"></p>
                                    </div>
                                </div>
                                <div class="col-md-10 col-md-offset-2">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Payment Period</label>
                                                <p><b>{contract.payment_recurrence_method}</b></p>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Rent Due Day</label>
                                                <p><b>{contract.rent_due_day}</b></p>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Security Deposit Owed</label>
                                                <p><b>{this.currencyFormat(Number(contract.security_deposit / 100))}</b></p>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Rent Amount</label>
                                                <p><b>{this.currencyFormat(Number(contract.contract_amount / 100))}</b></p>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Lease Renewal Date</label>
                                                <p><b>{moment(contract.contract_expiration_date).format('MMMM Do YYYY')}</b></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 col-md-offset-4">
                                    <div class="form-group">
                                        <label for="assignee">Signature</label>
                                        <input type="text" class="form-control" onChange={this.signatureChange.bind(this)} value={name} id="signature" placeholder="John Doe" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="content" style={{textAlign: 'center'}}>
                                    <button type="button" disabled={disabled} id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-secondary btn-fill" autoComplete="off" onClick={this.sign.bind(this)}>
                                    E-Sign Lease Agreement
                                    </button>
                                    <div class="clearfix"></div>
                                    <div class="col-md-6 col-md-offset-3">
                                        <p><small>By clicking <b>"E-Sign Lease Agreement"</b>, you are signing this
    Agreement electronically. You agree your electronic signature is the legal equivalent of your
    manual signature on this Agreement. By clicking <b>"E-Sign Lease Agreement"</b> you consent to be legally bound
    by this Agreement's terms and conditions.</small></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Signature/ElectronicLeaseSigning.jsx